import { stadiumApi, porticoApi } from 'utils/axios'

export const fetchConfigurations = (venueUuid, config) =>
  stadiumApi.get('/operator/device_manager/app_device_configurations', {
    params: { venue_uuid: venueUuid },
    ...config,
  })

export const deleteConfiguration = (uuid, config) =>
  stadiumApi.delete(`/operator/device_manager/app_device_configurations/${uuid}`, {
    ...config,
  })

export const createConfiguration = (payload, config) =>
  stadiumApi.post('/operator/device_manager/app_device_configurations', payload, config)

export const updateConfiguration = (payload, config) =>
  stadiumApi.put('/operator/device_manager/app_device_configurations', payload, config)

export const fetchPrinters = (venueUuid, config) =>
  stadiumApi.get('/operator/device_manager/printers', {
    params: { venue_uuid: venueUuid },
    ...config,
  })

export const deletePrinter = (uuid, config) =>
  stadiumApi.delete(`/operator/device_manager/printers/${uuid}`, {
    ...config,
  })

export const createPrinter = (payload, config) =>
  stadiumApi.post('/operator/device_manager/printers', payload, config)

export const updatePrinter = (payload, config) =>
  stadiumApi.put('/operator/device_manager/printers', payload, config)

export const fetchVenues = () => porticoApi.get(`/devices/venues`)

export const fetchDevices = (venueUuid) => porticoApi.get(`devices/manager?venue_uuid=${venueUuid}`)

export const fetchDevice = (venueUuid, deviceId) =>
  porticoApi.get(`devices/manager/${deviceId}?venue_uuid=${venueUuid}`)

export const deleteDevice = (venueUuid, deviceId) =>
  porticoApi.delete(`devices/manager/${deviceId}?venue_uuid=${venueUuid}`)

export const updateDevice = (payload, config) => porticoApi.put(`devices/manager`, payload, config)

export const bulkUpdateDevice = (payload, config) =>
  porticoApi.put(`devices/manager/bulk_update`, payload, config)

export const createDevice = (payload, config) => porticoApi.put(`devices/manager`, payload, config)

export const fetchRevenues = (venueUuid) =>
  stadiumApi.get('/pos/stands', {
    params: { venue_uuid: venueUuid },
  })

export default {
  fetchConfigurations,
  deleteConfiguration,
  createConfiguration,
  updateConfiguration,
  fetchPrinters,
  deletePrinter,
  createPrinter,
  updatePrinter,
  fetchVenues,
  fetchDevices,
  fetchDevice,
  deleteDevice,
  updateDevice,
  bulkUpdateDevice,
  createDevice,
  fetchRevenues,
}
